import * as yup from 'yup';

import {
  DIGITS_ONLY_REGEX,
  EMAIL_VALIDATION_REGEX,
  ERROR_INVALID_EMAIL,
  ERROR_REQUIRED_FIELD_WITH_NAME,
} from '@/constants';
import { ILoginWithCredentialsPayload, IOTPVerificationPayload } from '@/interfaces';

import { createNameofProxy } from '@/lib/ui';

export const LOGIN_SCHEMA = yup.object().shape({
  username: yup
    .string()
    .required(ERROR_REQUIRED_FIELD_WITH_NAME('ST Engineering email'))
    .matches(EMAIL_VALIDATION_REGEX, ERROR_INVALID_EMAIL),
  password: yup.string().trim().required(ERROR_REQUIRED_FIELD_WITH_NAME('Password')),
}) as yup.ObjectSchema<ILoginWithCredentialsPayload>;

export const LOGIN_FORM_FIELDS = createNameofProxy<ILoginWithCredentialsPayload>();

const ERROR_INVALID_OTP = 'Enter the 6-digit OTP.';

export const DEFAULT_OTP_EXPIRY_SECONDS = 600; // 10 minutes
export const DEFAULT_RESEND_OTP_EXPIRY_SECONDS = 180; // 3 minutes
export const DEFAULT_OTP_LENGTH = 6;
export const DEFAULT_MAX_RESEND_ATTEMPTS = 3;
export const DEFAULT_MAX_INVALID_OTP_ATTEMPTS = 3;

export const OTP_SCHEMA = yup.object().shape({
  otp: yup
    .string()
    .required(ERROR_REQUIRED_FIELD_WITH_NAME('OTP Code'))
    .matches(DIGITS_ONLY_REGEX, ERROR_INVALID_OTP)
    .length(DEFAULT_OTP_LENGTH, ERROR_REQUIRED_FIELD_WITH_NAME('OTP Code')),
}) as yup.ObjectSchema<IOTPVerificationPayload>;

export const OTP_FORM_FIELDS = createNameofProxy<IOTPVerificationPayload>();
